module.exports = __webpack_public_path__ + "img/banner-sheji.d619398b.jpg";